export default __webpack_public_path__ + "static/media/Icon5.3d08244b.svg";